var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9925 4.25328C16.4507 2.7302 18.5962 3.34398 19.885 4.32166C20.4135 4.72253 20.6777 4.92298 20.8332 4.92298C20.9887 4.92298 21.2528 4.72253 21.7813 4.32166C23.0702 3.34398 25.2157 2.7302 27.6738 4.25328C30.9 6.25215 31.63 12.8465 24.1887 18.41C22.7713 19.4697 22.0627 19.9993 20.8332 19.9993C19.6037 19.9993 18.895 19.4697 17.4777 18.41C10.0364 12.8465 10.7664 6.25215 13.9925 4.25328Z",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 23.3333H10.6579C11.1481 23.3333 11.6316 23.4438 12.0701 23.6559L15.4734 25.3026C15.9119 25.5148 16.3954 25.6251 16.8857 25.6251H18.6233C20.304 25.6251 21.6665 26.9436 21.6665 28.5699C21.6665 28.6356 21.6215 28.6934 21.5562 28.7114L17.3213 29.8824C16.5616 30.0924 15.7482 30.0193 15.0415 29.6773L11.4034 27.9171",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 27.5L29.3212 25.1482C30.6782 24.7254 32.145 25.2267 32.995 26.4039C33.6097 27.2549 33.3593 28.4737 32.464 28.9904L19.938 36.2175C19.1413 36.6772 18.2013 36.7894 17.3252 36.5294L6.6665 33.3665",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathy);
export default __webpack_public_path__ + "static/media/Empathy.3a33f56eb41a2ef29569816a9eba2445.svg";
export { ForwardRef as ReactComponent };